export default "__VITE_ASSET__2gRkqxAx__"